import React from "react";

export default function Button({children, ...props}) {
  let updatedProps = props;
  updatedProps.className = "btn btn-info text-white " + (updatedProps.className ?? '');

  return <button {...updatedProps}>{children}</button>
}
